import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';
import { profileSummaryApi } from '../api/profileSummary';

export function useProfileSummary() {
  return useQuery({
    queryKey: queryKeys.lms.profileSummary(),
    queryFn: async () => {
      const { data } = await profileSummaryApi.get();
      return data;
    },
    staleTime: 60_000,
  });
}
